import { pipego } from 'api/pipego';
import { whatsappOficialApi } from 'api/whatsappOficialApi';
import whatsappUtils from 'api/whatsapp-utils';
import { useNotifyAlert } from 'context/NotifyAlert';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { useState } from 'react';
import { getUserId, getWhatsappUserInfo } from 'util/isAdmin';

export const useChatArea = () => {
	const whatsappUserInfo = getWhatsappUserInfo();
	const userId = getUserId();
	const profileType = whatsappUserInfo?.profile_type_id;
	const isAdmin = profileType === 1;
	const { setShowNotify } = useNotifyAlert();
	const { selectedChat, setSelectedChat, setConversations } = useMessage();

	const [ visible, setVisible ] = useState( false );

	const handleOpenModal = () => {
		setVisible( true );
	};

	const handleCloseModal = () => {
		setVisible( false );
	};

	const handleFetchOperators = async () => {
		const response = await whatsappUtils.listUsers();

		return response.map( item => ( { ...item, id: item.acordoFechadoId } ) );
	};

	const handleUpdateOperator = async ( jid, operatorId, operatorEmail ) => {
		if ( selectedChat?.source === 'oficial' ) {
			try {
				const phone = jid.split( '@' )[0];
				const response = await whatsappOficialApi.updateOperator( phone, operatorId );
				const newStatus = response?.data?.status;
				const update = { userId: operatorId, userEmail: operatorEmail, operatorEmail, ...( newStatus !== undefined ? { status: newStatus } : {} ) };
				setSelectedChat( prev => prev?.id === jid ? { ...prev, ...update } : prev );
				setConversations( prev => prev.map( c => c.id === jid ? { ...c, ...update } : c ) );
				setShowNotify( {
					text   : 'Responsável atualizado com sucesso',
					status : 'success'
				} );
			} catch ( error ) {
				setShowNotify( {
					text   : error?.response?.data?.error || 'Erro ao atualizar responsável',
					status : 'error'
				} );
			}
			return;
		}

		const response = await pipego.updateOperator( jid, operatorId, operatorEmail );
		if ( response.status === 200 ) {
			setSelectedChat(prev => prev.id === response.data.id ? ({...prev, ...response.data}) : prev );
			setShowNotify( {
				text   : 'Responsável atualizado com sucesso',
				status : 'success'
			} );
		} else {
			setShowNotify( {
				text   : 'Erro ao atualizar responsável',
				status : 'error'
			} );
		}
	};

	return { isAdmin, profileType, userId, visible, handleOpenModal, handleCloseModal, handleFetchOperators, handleUpdateOperator, selectedChat, whatsappUserInfo };
};
